import "./RaikoEditorItemsContainer.scss"
import TextEditorDeleteAction from "../deleteAction/TextEditorDeleteAction";


export default function RaikoEditorItemsContainer({children, value, setValue, priority}) {


    return (
        <div className={"baseRaikoEditorItemsContainer"}>
            {children}
            <TextEditorDeleteAction priority={priority} setValue={setValue} value={value}/>
        </div>
    )
}
